import { useState } from "react";
import { PawPrint, Plus } from "@phosphor-icons/react";
import { usePets } from "@/context/PetProfileContext";

export default function PackBar() {
  const { pets, activeId, setActiveId, addPet } = usePets();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", breed: "Pit Bull", size: "M" });

  return (
    <div className="mb-10 p-5 rounded-2xl bg-card border border-secondary/20" data-testid="pack-bar">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2"><PawPrint weight="duotone" className="text-secondary" size={20} /><span className="overline text-secondary">Your Pack · gear auto-fits their size</span></div>
        <button onClick={() => setOpen((o) => !o)} className="overline text-secondary inline-flex items-center gap-1" data-testid="pack-add-toggle"><Plus size={14} /> Add pet</button>
      </div>
      <div className="flex gap-3 flex-wrap">
        {pets.map((p) => (
          <button key={p.id} onClick={() => setActiveId(p.id)}
            className={`px-4 py-2 rounded-full border transition-colors ${activeId === p.id ? "border-secondary bg-secondary/15 text-secondary" : "border-white/15 text-muted-foreground hover:text-white"}`}
            data-testid={`pack-pet-${p.id}`}>
            <span className="font-modern text-sm">{p.name}</span> <span className="text-xs opacity-70">· {p.breed} · {p.size}</span>
          </button>
        ))}
      </div>
      {open && (
        <form onSubmit={(e) => { e.preventDefault(); if (!form.name) return; addPet(form); setForm({ name: "", breed: "Pit Bull", size: "M" }); setOpen(false); }}
          className="mt-4 flex flex-col sm:flex-row gap-3" data-testid="pack-add-form">
          <input required placeholder="Pet name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="flex-1 bg-transparent border border-white/15 rounded-lg px-4 py-2.5 outline-none focus:border-secondary transition-colors" data-testid="pack-name" />
          <input placeholder="Breed" value={form.breed} onChange={(e) => setForm({ ...form, breed: e.target.value })} className="flex-1 bg-transparent border border-white/15 rounded-lg px-4 py-2.5 outline-none focus:border-secondary transition-colors" />
          <select value={form.size} onChange={(e) => setForm({ ...form, size: e.target.value })} className="bg-card border border-white/15 rounded-lg px-4 py-2.5 outline-none focus:border-secondary transition-colors" data-testid="pack-size">
            {["S", "M", "L"].map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <button className="bg-secondary text-secondary-foreground px-6 py-2.5 rounded-full font-modern font-medium" data-testid="pack-save">Save</button>
        </form>
      )}
    </div>
  );
}
